import React, { useEffect, useState } from "react";
import { ITkResigneeSearchModalProps } from "../../../type/componentsType/TkResigneeModal.d";
import TkModalWithTitle from "../../atoms/TkModalWithTitle";
import TkDataTable from "../TkDataTable";
import { ITkDataTableHeadePorps } from "../../../type/componentsType/TkDataTable";
import TkRadio from "../../atoms/TkRadio";
import { Alert, Box, Typography } from "@mui/material";
import TkLabelText from "../../atoms/TkLabelText";
import "./_style.scss";
import TkButton from "../../atoms/TkButton";
import TkCheckbox from "../../atoms/TkCheckbox";
import TkDatePicker from "../../atoms/TkDatePicker";
import TkPropertyMessageGet from "../../../utils/TkPropertyMessageGet";

/**
 * TkResigneeSearchModalコンポーネント
 * @component
 * @param {ITkResigneeSearchModalProps} props - コンポーネントのプロパティ
 * @param {boolean} props.open - 表示／非表示。
 * @param {boolean} props.useCheck - ラジオボタン選択形式／チェックボックス選択形式。
 * @returns {React.FC} TkResigneeSearchModalコンポーネント
 */
const TkResigneeSearchModal: React.FC<ITkResigneeSearchModalProps> = (
  props
) => {
  const {
    open,
    listData,
    useCheck = false,
    isHoujin = false,
    onChangeSearchData,
    onSave,
    onClose,
  } = props;

  const [bodyList, setBodyList] = useState<any>();
  const [selectItem, setSelectItem] = useState<any>();
  const [formValues, setFormValues] = useState({});
  const [error, setError] = useState(false);
  const [dateError, setDateError] = useState(false);
  const [errorMsg, setErrorMsg] = useState<any>({});

  const handleOnChange = (field: any) => (event: any) => {
    const validationStrategies: any = {
      contractorNo: (value: string) => {
        if (!value.match(/^(\d{6})?$/)) {
          setErrorMsg({
            ...errorMsg,
            contractorNo: TkPropertyMessageGet("TKMSG_SCR0077E", "6"),
          });
        } else {
          setErrorMsg({
            ...errorMsg,
            contractorNo: "",
          });
        }
      },
      contractorName: (value: string) => {
        if (!value.match(/^([^ -~｡-ﾟ])*$/)) {
          setErrorMsg({
            ...errorMsg,
            contractorName: TkPropertyMessageGet("TKMSG_SCR0061E"),
          });
        } else if (value.length > 85) {
          setErrorMsg({
            ...errorMsg,
            contractorName: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
          });
        } else {
          setErrorMsg({
            ...errorMsg,
            contractorName: "",
          });
        }
      },
      staffNo: (value: string) => {
        if (!value.match(/^(\d{5})?$/)) {
          setErrorMsg({
            ...errorMsg,
            staffNo: TkPropertyMessageGet("TKMSG_SCR0077E", "5"),
          });
        } else {
          setErrorMsg({
            ...errorMsg,
            staffNo: "",
          });
        }
      },
      retirementStaffName: (value: string) => {
        if (!value.match(/^([^ -~｡-ﾟａ-ｚＡ-Ｚ])*$/)) {
          setErrorMsg({
            ...errorMsg,
            retirementStaffName: TkPropertyMessageGet("TKMSG_SCR0073E"),
          });
        } else if (value.length > 48) {
          setErrorMsg({
            ...errorMsg,
            retirementStaffName: TkPropertyMessageGet("TKMSG_SCR0046E", "48"),
          });
        } else {
          setErrorMsg({
            ...errorMsg,
            retirementStaffName: "",
          });
        }
      },
    };

    validationStrategies[field]?.(event.target.value);

    const resObj = {
      ...formValues,
      [field]: event.target.value,
    };
    setFormValues(resObj);
  };

  const headList: ITkDataTableHeadePorps[] = [
    {
      headTitle: "選択",
      dontNeedSort: true,
    },
    {
      headTitle: "契約者名",
    },
    {
      headTitle: "施設名",
    },
    {
      headTitle: "退職者名",
    },
    {
      headTitle: "生年月日",
    },
    {
      headTitle: "退職日",
    },
  ];

  const handelItemSelect = (e: any) => {
    if (useCheck) {
      const res = e;
      setSelectItem((prevSelectItem: any) => {
        if (prevSelectItem) {
          return prevSelectItem.includes(res)
            ? prevSelectItem.filter((item: any) => item !== res)
            : [...prevSelectItem, res];
        } else {
          return [res];
        }
      });
      return;
    }

    setSelectItem(e);
  };

  const handleSearch = () => {
    if (Object.values(formValues).every((item) => !item)) {
      setError(true);
      return;
    }
    if (Object.values(errorMsg).some((item) => item) || dateError) {
      return;
    }

    setError(false);
    onChangeSearchData && onChangeSearchData(formValues);
  };

  const handleOnSave = () => {
    setError(false);
    onSave && onSave(selectItem);
  };

  const handleOnClose = () => {
    setError(false);
    onClose && onClose();
  };

  useEffect(() => {
    setFormValues({});
  }, [open]);

  useEffect(() => {
    const renderList = listData.map((item: any) => {
      const {
        contractorNo,
        contractorName,
        facilityNo,
        facilityName,
        staffNo,
        retirementStaffName,
        birthday,
        retireDate,
      } = item;
      const list = [
        {
          children: useCheck ? (
            <TkCheckbox
              checked={selectItem && selectItem.includes(item) ? true : false}
              onClick={() => handelItemSelect(item)}
            />
          ) : (
            <TkRadio
              checked={
                selectItem &&
                selectItem?.contractorNo === contractorNo &&
                selectItem?.facilityNo === facilityNo &&
                selectItem?.staffNo === staffNo
                  ? true
                  : false
              }
              onClick={() => handelItemSelect(item)}
            />
          ),
          width: 40,
        },
        {
          children: (
            <Typography>
              {contractorNo}:{contractorName}
            </Typography>
          ),
          forSort: contractorNo,
          width: 220,
        },
        {
          children: (
            <Typography>
              {facilityNo} :{facilityNo === "999" ? "対象外施設" : facilityName}
            </Typography>
          ),
          forSort: facilityNo,
          width: 220,
        },
        {
          children: (
            <Typography>
              {staffNo} : {retirementStaffName}
            </Typography>
          ),
          forSort: staffNo,
          width: 220,
        },
        {
          children: <Typography>{birthday}</Typography>,
          forSort: birthday,
          width: 130,
        },
        {
          children: <Typography>{retireDate}</Typography>,
          forSort: retireDate,
          width: 130,
        },
      ];

      return list;
    });

    setBodyList([...renderList]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listData, selectItem]);

  return (
    <TkModalWithTitle
      title="退職者検索"
      saveData={selectItem}
      clearSaveData={() => setSelectItem(null)}
      open={open}
      saveButtonDisabled={!selectItem || (useCheck && !selectItem?.length)}
      onSave={handleOnSave}
      onClose={handleOnClose}
      className={"TkResigneeSearchModalScroll"}
    >
      <>
        {error && (
          <Alert severity="error">
            {TkPropertyMessageGet("TKMSG_SVR0067E")}
          </Alert>
        )}
        <Box className={"TkModalWithTitleSec"}>
          {!isHoujin && (
            <>
              <TkLabelText
                onChange={handleOnChange("contractorNo")}
                label="共済契約者番号"
                variant="standard"
                inputProps={{ maxLength: 6 }}
                error={!!errorMsg.contractorNo}
                helperText={errorMsg.contractorNo}
              />
              <TkLabelText
                onChange={handleOnChange("contractorName")}
                label="契約者名"
                variant="standard"
                inputProps={{ maxLength: 85 }}
                error={!!errorMsg.contractorName}
                helperText={errorMsg.contractorName}
              />
            </>
          )}
          <TkLabelText
            onChange={handleOnChange("staffNo")}
            label="法人職員番号"
            variant="standard"
            inputProps={{ maxLength: 5 }}
            error={!!errorMsg.staffNo}
            helperText={errorMsg.staffNo}
          />
          <TkLabelText
            onChange={handleOnChange("retirementStaffName")}
            label="退職者名"
            variant="standard"
            inputProps={{ maxLength: 48 }}
            error={!!errorMsg.retirementStaffName}
            helperText={errorMsg.retirementStaffName}
          />
          <TkDatePicker
            onChange={handleOnChange("retirementStaffBirth")}
            label="生年月日"
            minDate={new Date("1900/01/01")}
            maxDate={new Date()}
            onGetErrorFlg={setDateError}
          />

          <TkButton onClick={handleSearch}>検索</TkButton>
        </Box>
        <TkDataTable useScroll bodyList={bodyList} headList={headList} />
      </>
    </TkModalWithTitle>
  );
};

export default TkResigneeSearchModal;
